import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'
import { FormContext } from '../../../pages/_app'
import { parseHtml } from '../../../utils/common'
// import "./bookconsultant.scss";
import dynamic from "next/dynamic";

const HocButton = dynamic(() => import('../../HigherOrderComponent/HocButton'))

function BookConsultant(props) {
	const { showForm } = useContext(FormContext)
	const [ctaButton, setCtaButton] = useState({})
	let block = props.block
	let buttonLabel =
		block?.button?.label ||
		block?.ready_made?.label ||
		block?.buttons[0]?.link?.label

	useEffect(() => {
		if (block?.button?.label) {
			setCtaButton(block.button)
		}
		if (block?.ready_made?.label) {
			setCtaButton(block.ready_made)
		}
		if (block?.buttons?.[0]?.link?.label) {
			setCtaButton(block?.buttons[0]?.link)
		}
	}, [block])

	return (
		<>
			<section className="book-section bg-one home-padding-new ">
				<div className="book-inner">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="book-box bottom-book-box">

									<div className="row justify-content-center">
										<div className="col-lg-8 col-md-10">
											<div className="book-text">
												<h2>{block.title}</h2>
												{block?.text ? <p>{block?.text}</p> : <></>}
												{block.description
													? parseHtml(block.description, true)
													: ''}
												<div className="hire-btn">
													<HocButton
														button={ctaButton}
														btnAction={() => showForm()}
													>
														<Link
															href="/request-proposal"
															className="btn btn-primary"
														>
															{ctaButton.label}
														</Link>
													</HocButton>
													{block.from_scratch ? (
														<HocButton
															button={block?.from_scratch}
															btnAction={() => showForm()}
														>
															<Link
																href="/request-proposal"
																className="btn btn-secondary"
															>
																{block?.from_scratch.label}
															</Link>
														</HocButton>
													) : null}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default BookConsultant
